import type { RootState } from "@/app/store/type";


export const selectMapFilterData = (state: RootState) => state.mapFilterData;